import { useQuery } from "react-query";
import { getDescriptiveGroup } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useDescriptiveGroup = () => {
    const { data, isLoading, refetch } = useQuery(
        "getDescriptiveGroup",
        getDescriptiveGroup,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};